import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, type Analytics } from "firebase/analytics";
import firebaseConfig from "../../firebase-config.json";

const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);

let _analytics: Analytics | null = null;
try {
  _analytics = getAnalytics(app);
} catch {
  // Analytics unavailable (e.g. blocked by ad blocker, no measurementId)
}
export const analytics = _analytics;

// Connect to Firebase Auth Emulator in development
// if ((import.meta as any).env.VITE_FIREBASE_EMULATOR_ENABLED === "true") {
//   try {
//     connectAuthEmulator(firebaseAuth, "http://127.0.0.1:9099", {
//       disableWarnings: true,
//     });
//     console.log("✅ Firebase Auth Emulator connected");
//   } catch (error) {
//     console.warn(
//       "⚠️ Firebase Auth Emulator not available. Make sure to run: firebase emulators:start",
//       error,
//     );
//   }
// }
